import "sanitize.css";
import "sanitize.css/assets.css";
import "sanitize.css/typography.css";
import "sanitize.css/forms.css";
import "sanitize.css/reduce-motion.css";
import "@fontsource-variable/inter";

import { createApp } from "vue";
import App from "./App.vue";

const app = createApp(App);
app.mount("#app");
